import React, { useEffect } from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import config from "../../config";
import { useAuth } from "../../AuthContext";

const GeocodeLogger = () => {
  const { getAccessToken } = useAuth();

  useEffect(() => {
    const baseUrl = config.API_URL?.replace(/\/+$/, "") ?? "";

    const connection = new HubConnectionBuilder()
      .withUrl(`${baseUrl}/geocodeHub`, {
        accessTokenFactory: async () => (await getAccessToken()) ?? "",
      })
      .withAutomaticReconnect()
      .build();

    connection
      .start()
      .then(() => {
        console.log("Connected to SignalR hub");
        connection.on("geocodeHub", (data) => {
          console.log("Received location update:", data);
        });
      })
      .catch((err) => console.error("SignalR connection error:", err));

    return () => {
      connection.stop();
    };
  }, [getAccessToken]);

  return <div>Listening for address validation updates... geocodeHub</div>;
};

export default GeocodeLogger;
